import React from 'react';
import { Target } from 'lucide-react';

export const JobTargetBanner = ({ formData, onOpen }) => {
  const jd = formData?.jobDescription;
  if (!jd?.trim()) return null;

  // Extract a company name hint from JD (first capitalized proper noun after "at " or "for ")
  const match = jd.match(/(?:at|for|join)\s+([A-Z][a-zA-Z]+(?:\s[A-Z][a-zA-Z]+)?)/);
  const company = match?.[1] || 'this role';

  return (
    <div className="flex items-center justify-between gap-3 px-4 py-2.5 bg-gradient-to-r from-blue-50 to-violet-50 border-b border-blue-100">
      <div className="flex items-center gap-2 min-w-0">
        <Target className="w-3.5 h-3.5 text-blue-600 flex-shrink-0" />
        <span className="text-xs font-semibold text-blue-800 truncate">
          Targeting: <strong>{company}</strong>
        </span>
      </div>
      <button
        onClick={onOpen}
        className="text-[11px] font-bold text-blue-600 hover:text-blue-800 transition-colors whitespace-nowrap flex-shrink-0"
      >
        Change Job →
      </button>
    </div>
  );
};
